const TRANFORM_URL_TOOLS = {
    1: 'zoom',
    2: 'attribution',
    3: 'scaleline',
    4: 'scalebox',
    5: 'mouseposition',
    6: 'geolocation',
    7: 'fullscreen',
    8: 'layerswitcher',
    9: 'streetview',
    10: 'backoffice',
    11: 'expandcollapse',
    12: 'dashboard',
    13: 'navsearch',
    14: 'catalog',
    15: 'identify',
    16: 'print_visible_emissions',
    17: 'annotations',
};

export const convertSettingsUrl = (route, defaultData={}) => {
    let tools = getUrlParam('tools', route);
    if(tools) {
        let transformedTools = {};
        tools.split(",").forEach(item => {
            let key = TRANFORM_URL_TOOLS[item.trim()];
            transformedTools[key] = defaultData;
        });
        return transformedTools;
    }
    return null;
};

export const getUrlParam = (key, route=null) => {
    if(route) {
        const queryString = route.query;
        return queryString[key];
    }else{
        const queryString = window.location.search;
        if (queryString) {
            // let GET_parameters = {};
            // var splitts = queryString.substring(1).split('&');
            // for (var i = 0; i < splitts.length; i++) {
            //     var key_value_pair = splitts[i].split('=');
            //     if (!key_value_pair[0]) continue;
            //     GET_parameters[key_value_pair[0]] = key_value_pair[1] || true;
            // }
            const urlParams = new URLSearchParams(queryString);
            return urlParams.get(key);
        }
    }
};